<template>
  <v-btn-toggle dense>

    <template v-if="pages[pageType]!==undefined">
      <template v-for="(mainItem, mainItemI) in pages[pageType].items">
        <template v-if="mainItem.hidden!==false ? isHidden(mainItem.hidden) : true">
          <template v-if="mainItem.subItems!==undefined">
            <v-menu :key="mainItemI" open-on-hover offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined dense small v-bind="attrs" v-on="on" :disabled="disableMenuItem(pageType, mainItem.name)">
                  <template v-if="(mainItem.badge!==false)?hasBadge(mainItem.badge):false">
                    <v-badge left color="error" :content="hasBadge(mainItem.badge)">{{mainItem.name}}</v-badge>
                  </template>
                  <template v-else>{{mainItem.name}}</template>
                </v-btn>
              </template>
              <v-list dense>
                <template v-for="(subItem,subItemI) in mainItem.subItems">
                  <template v-if="!subItem.hidden ? true : isSubItemHidden(subItem.hidden)">
                    <div :key="subItemI" @click="subItem.permissions && !hasUserGotRoles(subItem.permissions) ? showPermissionError(subItem.id) : ''">
                      <v-list-item dense :key="subItemI" @click="subItem.method" :disabled="(subItem.disabled!==false)?isDisabled(subItem.disabled):false || subItem.permissions ? !hasUserGotRoles(subItem.permissions): false">
                        <v-list-item-title>{{ subItem.name }}</v-list-item-title>
                      </v-list-item>
                    </div>
                  </template>
                </template>
              </v-list>
            </v-menu>
          </template>
          <template v-else>
            <v-btn :disabled="(mainItem.disabled!==undefined)?isDisabled(mainItem.disabled):false" outlined dense small :key="mainItemI" @click="mainItem.method">
              <template v-if="(mainItem.badge!==false)?hasBadge(mainItem.badge):false">
                <v-badge left color="error" :content="hasBadge(mainItem.badge)">{{mainItem.name}}</v-badge>
              </template>
              <template v-else>{{mainItem.name}}</template>
            </v-btn>
          </template>
        </template>
      </template>
    </template>

    <v-btn dense small color="secondary" @click="$emit('open-search')"><v-icon color="white">search</v-icon></v-btn>

    <template v-if="additionalButtons">
      <template v-for="(addBtn,addBtnI) in additionalButtons">
        <v-btn :color="addBtn.color" dense small @click="$emit('add-button',addBtn.method)" v-html="addBtn.inner" :key="addBtnI"></v-btn>
      </template>
    </template>

  </v-btn-toggle>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  export default {
    props: ['pageType','additionalButtons'],
    data() {
      return {
        pages: {
          creditControl: {
            items: {
              oldCC: {
                name: 'OLD CC',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('goToOldCc');},
              },
              ledger: {
                name: 'LEDGER',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('goToLedger');},
              },
              tools: {
                name: 'Tools',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  recover: { name: 'RECOVER FROM HANDED OVER',method: ()=>{this.emitMethod('recoverFromHandedOver');},disabled: false,hidden: false },
                  handOver: { name: 'HAND OVER',method: ()=>{this.emitMethod('handOver');},disabled: false,hidden: false },
                  writeOff: { name: 'WRITE OFF',method: ()=>{this.emitMethod('writeOff');},disabled: false,hidden: false },
                  dead01Udd: { name: 'MOVE TO DEAD 01 UDD',method: ()=>{this.emitMethod('dead01Udd');},disabled: false,hidden: false },
                  recoverFromDead01Udd: { name: 'RECOVER FROM DEAD 01 UDD',method: ()=>{this.emitMethod('recoverFromDead01Udd');},disabled: false,hidden: false },
                }
              },
            }
          },
          daily: {
            items: {
              newLead: {
                name: 'New Lead',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('newLead');},
              },
            }
          },
          account: {
            items: {
              commsPage: {
                name: 'Comms',
                disabled: false,
                badge: 'comms',
                hidden: false,
                method: () => {this.emitMethod('comms')},
              },
              creditControl: {
                name: 'Credit Control',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('goToCreditControl');},
              },
              finance: {
                name: 'Finance',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  addCreditNoteProposal: { name: 'ADD CREDIT NOTE PROPOSAL',method: ()=>{this.emitMethod('addCreditNoteProposal');},disabled: false,hidden: false },
                  takePayment: { name: 'TAKE PAYMENT',method: ()=>{this.emitMethod('takePayment');},disabled: false,hidden: false },
                  sendPaymentLink: { name: 'SEND PAYMENT LINK',method: ()=>{this.emitMethod('sendPaymentLink');},disabled: false,hidden: false },
                  sendPaymentLinkSMS: { name: 'SEND PAYMENT LINK SMS',method: ()=>{this.emitMethod('sendPaymentLinkSMS');},disabled: false,hidden: false },
                  sendAccountStatement: { name: 'SEND ACCOUNT STATEMENT',method: ()=>{this.emitMethod('sendAccountStatement');},disabled: false,hidden: false },
                  sendDirectDebitMandate: { name: 'SEND DIRECT DEBIT MANDATE',method: ()=>{this.emitMethod('sendDirectDebitMandate');},disabled: false,hidden: false },
                  directDebitMandateHistory: { name: 'DIRECT DEBIT MANDATE HISTORY',method: ()=>{this.emitMethod('directDebitMandateHistory');},disabled: false,hidden: false },
                  billingQueue: { name: 'BILLING QUEUE',method: ()=>{this.emitMethod('billingQueue');},disabled: false,hidden: false },
                  resetCop: { name: 'RESET COP', method: () => {this.emitMethod('resetCop');}, disabled: false, hidden: false },
                }
              },
              tools: {
                name: 'Tools',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  sendContactRequestEmail: { name: 'SEND CONTACT REQUEST EMAIL',method: ()=>{this.emitMethod('sendContactRequestEmail');},disabled: false,hidden: false },
                  escalate: { name: 'ESCALATE',method: ()=>{this.emitMethod('escalate');},disabled: false,hidden: false },
                  sendSMS: { name: 'SEND SMS',method: ()=>{this.emitMethod('sendSMS');},disabled: false,hidden: false },
                }
              },
              marketing: {
                name: 'Marketing',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  sendPortalInvitation: { name: 'SEND PORTAL INVITATION',method: ()=>{this.emitMethod('sendPortalInvitation');},disabled: false,hidden: false },
                  sendBrochure: { name: 'SEND BROCHURE',method: ()=>{this.emitMethod('sendBrochure');},disabled: false,hidden: false },
                }
              },
              ledger: {
                name: 'Ledger',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('goToLedger');},
              },
              accountAudit: {
                name: 'Audit',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('showAccountAudit');},
              },
            }
          },
          productVoip: {
            items: {
              commsPage: {
                name: 'Comms',
                disabled: false,
                badge: 'comms',
                hidden: false,
                method: () => {this.emitMethod('comms')},
              },
              ticketsPage: {
                name: 'Tickets',
                disabled: false,
                badge: 'escalation',
                hidden: false,
                subItems: {
                  newTicket: { name: 'NEW TICKET',method: ()=>{this.emitMethod('newTicket');},disabled: false,hidden: false },
                  ticketsPage: { name: 'VIEW TICKETS',method: ()=>{this.emitMethod('ticketsPage');},disabled: false,hidden: false },
                }
              },
              contractList: {
                name: 'Contracts',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('contractList');},
              },
              statusHistory: {
                name: 'Status History',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('statusHistory');},
              },
              adhoc: {
                name: 'Ad Hoc',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  adhocHistory: { name: 'SHOW HISTORY',method: ()=>{this.emitMethod('adhocHistory');},disabled: false,hidden: false },
                  adhocCreateInvoice: { id: "create-invoice", name: 'CREATE INVOICE',method: ()=>{this.emitMethod('adhocCreateInvoice');},disabled: false,hidden: false, permissions: ['post-sale-adhoc'] },
                  hardwareOrderingQueue: { name: 'HARDWARE ORDERING QUEUE',method: ()=>{this.emitMethod('hardwareOrderingQueue');},disabled: false,hidden: false },
                }
              },
              tools: {
                name: 'Tools',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  sendSMS: { name: 'SEND SMS',method: ()=>{this.emitMethod('sendSMS');},disabled: false,hidden: false },
                  sendTrustpilotEmail: { name: 'SEND TRUSTPILOT EMAIL', method: () => {this.emitMethod('sendTrustpilotEmail')}, disabled: false, hidden: false},
                  audit: { name: 'AUDIT', method: () => {this.emitMethod('audit')}, disabled: false, hidden: false },
                  linkAsCot: { name: 'LINK AS COT', method: () => {this.emitMethod('linkAsCot')}, disabled: false, hidden: false },
                  changeTariff: { name: 'CHANGE TARIFF', method: () => {this.emitMethod('changeTariff')}, disabled: 'changeTariff', hidden: 'changeTariff' },
                  legacyChangeTariffVoip: { name: 'LEGACY CHANGE TARIFF', method: () => {this.emitMethod('legacyChangeTariffVoip')}, disabled: false, hidden: 'legacyChangeTariffVoip'},
                  viewOnOldCrm: { name: 'VIEW ON OLD CRM', method: () => {this.emitMethod('viewOnOldCrm')}, disabled: false, hidden: false },
                  openCustomerPortal: { name: 'OPEN CUSTOMER PORTAL', method: ()=>{this.emitMethod('openCustomerPortal')}, disabled: false, hidden: false},
                }
              },
              goToLead: {
                name: 'Lead',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('goToLead');},
              },
            }
          },
          productTelco: {
            items: {
              commsPage: {
                name: 'Comms',
                disabled: false,
                badge: 'comms',
                hidden: false,
                method: () => {this.emitMethod('comms')},
              },
              ticketsPage: {
                name: 'Tickets',
                disabled: false,
                badge: 'escalation',
                hidden: false,
                subItems: {
                  newTicket: { name: 'NEW TICKET',method: ()=>{this.emitMethod('newTicket');},disabled: false,hidden: false },
                  ticketsPage: { name: 'VIEW TICKETS',method: ()=>{this.emitMethod('ticketsPage');},disabled: false,hidden: false },
                }
              },
              contractList: {
                name: 'Contracts',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('contractList');},
              },
              statusHistory: {
                name: 'Status History',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('statusHistory');},
              },
              cli: {
                name: 'CLI',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  cliHistory: { name: 'SHOW HISTORY',method: ()=>{this.emitMethod('cliHistory');},disabled: false,hidden: false },
                  changeCli: { name: 'CHANGE CLI',method: ()=>{this.emitMethod('changeCli');},disabled: false,hidden: false },
                }
              },
              adhoc: {
                name: 'Ad Hoc',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  adhocHistory: { name: 'SHOW HISTORY',method: ()=>{this.emitMethod('adhocHistory');},disabled: false,hidden: false },
                  adhocCreateInvoice: { id: "create-invoice", name: 'CREATE INVOICE',method: ()=>{this.emitMethod('adhocCreateInvoice');},disabled: false,hidden: false, permissions: ['post-sale-adhoc'] },
                  hardwareOrderingQueue: { name: 'HARDWARE ORDERING QUEUE',method: ()=>{this.emitMethod('hardwareOrderingQueue');},disabled: false,hidden: false },
                }
              },
              tools: {
                name: 'Tools',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  portToVoip: { name: 'PORT TO BONLINE VOIP',method: ()=>{this.emitMethod('portToVoip');},disabled: false,hidden: false },
                  createCOT: { name: 'CREATE COT',method: ()=>{this.emitMethod('createCOT');},disabled: false,hidden: false },
                  createCOP: { name: 'CREATE COP',method: ()=>{this.emitMethod('createCOP');},disabled: false,hidden: false },
                  changeTelcoTariff: { name: 'CHANGE TARIFF',method: ()=>{this.emitMethod('changeTelcoTariff');},disabled: false,hidden: false },
                  legacyTelcoTariff: { name: 'LEGACY CHANGE TARIFF',method: ()=>{this.emitMethod('legacyTelcoTariff');},disabled: false,hidden: false },
                  modemReplacement: { id: "modemReplacement",name: 'MODEM REPLACEMENT',method: ()=>{this.emitMethod('modemReplacement');},disabled: false,hidden: false, permissions: ['can-replace-modems'] },
                  edbEmail: { name: 'EDB Email',method: ()=>{this.emitMethod('edbEmail');},disabled: false,hidden: false },
                  sendSMS: { name: 'SEND SMS',method: ()=>{this.emitMethod('sendSMS');},disabled: false,hidden: false },
                  sendTrustpilotEmail: { name: 'SEND TRUSTPILOT EMAIL', method: () => {this.emitMethod('sendTrustpilotEmail')}, disabled: false, hidden: false},
                  audit: { name: 'AUDIT', method: () => {this.emitMethod('audit')}, disabled: false, hidden: false },
                  viewOnOldCrm: { name: 'VIEW ON OLD CRM', method: () => {this.emitMethod('viewOnOldCrm')}, disabled: false, hidden: false },
                  availabilityChecker: { name: 'AVAILABILITY CHECKER', method: () => {this.emitMethod('availabilityChecker')}, disabled: false, hidden: false }
                }
              },
              goToLead: {
                name: 'Lead',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('goToLead');},
              },
            }
          },
          productWebsite: {
            items: {
              commsPage: {
                name: 'Comms',
                disabled: false,
                badge: 'comms',
                hidden: false,
                method: () => {this.emitMethod('comms')},
              },
              ticketsPage: {
                name: 'Tickets',
                disabled: false,
                badge: 'escalation',
                hidden: false,
                subItems: {
                  newTicket: { name: 'NEW TICKET',method: ()=>{this.emitMethod('newTicket');},disabled: false,hidden: false },
                  ticketsPage: { name: 'VIEW TICKETS',method: ()=>{this.emitMethod('ticketsPage');},disabled: false,hidden: false },
                }
              },
              convertToWeb2: {
                name: 'Convert to Web2.0',
                disabled: false,
                badge: false,
                hidden: 'convertToWeb2',
                method: ()=>{this.emitMethod('convertToWeb2');},
              },
              statusHistory: {
                name: 'Status History',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('statusHistory');},
              },
              adhoc: {
                name: 'Ad Hoc',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  adhocHistory: { name: 'SHOW HISTORY',method: ()=>{this.emitMethod('adhocHistory');},disabled: false,hidden: false },
                  adhocCreateInvoice: { id: "create-invoice", name: 'CREATE INVOICE',method: ()=>{this.emitMethod('adhocCreateInvoice');},disabled: false,hidden: false, permissions: ['post-sale-adhoc'] },
                  hardwareOrderingQueue: { name: 'HARDWARE ORDERING QUEUE',method: ()=>{this.emitMethod('hardwareOrderingQueue');},disabled: false,hidden: false },
                }
              },
              tools: {
                name: 'Tools',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  sendSMS: { name: 'SEND SMS',method: ()=>{this.emitMethod('sendSMS');},disabled: false,hidden: false },
                  sendTrustpilotEmail: { name: 'SEND TRUSTPILOT EMAIL', method: () => {this.emitMethod('sendTrustpilotEmail')}, disabled: false, hidden: false},
                  audit: { name: 'AUDIT', method: () => {this.emitMethod('audit')}, disabled: false, hidden: false },
                  viewOnOldCrm: { name: 'VIEW ON OLD CRM', method: () => {this.emitMethod('viewOnOldCrm')}, disabled: false, hidden: false },
                }
              },
              goToLead: {
                name: 'Lead',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('goToLead');},
              },
            }
          },
          lead: {
            items: {
              finance: {
                name: 'Finance',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  sendDirectDebitMandate: { name: 'SEND DIRECT DEBIT MANDATE',method: ()=>{this.emitMethod('sendDirectDebitMandate');},disabled: false,hidden: false },
                }
              },
              createBilling: {
                name: 'CREATE BILLING ACCOUNT',
                disabled: false,
                badge: false,
                hidden: 'createBilling',
                method: ()=>{this.emitMethod('createBilling');},
              },
              sendSms: {
                name: 'SEND SMS',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('sendSms');},
              },
              audit: {
                name: 'AUDIT',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('audit');},
              },
              quote: {
                name: 'QUOTE',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('quote');},
              },
              oldcrm: {
                name: 'View on old CRM',
                disabled: false,
                badge: false,
                hidden: false,
                method: ()=>{this.emitMethod('viewOnOldCrm');},
              },
            }
          },
          retention: {
            items: {
              tools: {
                name: 'Tools',
                disabled: false,
                badge: false,
                hidden: false,
                subItems: {
                  sendProformaInvoice: { name: 'SEND PROFORMA INVOICE', method: ()=>{this.emitMethod('openSendProformaInvoiceDialog')}, disabled: false, hidden: false },
                }              
              }
            }
          },
          ticket: {
            items: {
              audit: {
                name: 'Audit',
                disabled: false,
                badge: false,
                hidden: false,    
                method: ()=>{this.emitMethod('audit');},      
              }
            }
          }
        },
      }
    },
    computed: {
      ...mapState('accounts', ['currentAccount']),
      ...mapState('products', ['currentProduct','openEscalations']),
      ...mapState('leads', ['currentLead']),
      ...mapGetters('globals',['getCurrentUserRoles','hasUserGotRole', 'hasUserGotRoles']),
      ...mapGetters('retention', ['getSingleRetentionLead']),
    },
    methods: {
      ...mapActions("alerts", ["setAlert"]),
      emitMethod(methodName){
        this.$emit('menuItemClick',methodName);
      },
      showPermissionError(id) {
        const permissionMap = {
          "create-invoice": "You do not have permission to make additional ad hoc invoices",
          "modemReplacement": "You do not have permission to replace the users hardware",
        };
        this.setAlert({ message: permissionMap[id], type: "error" });
      },
      isDisabled(item){
        let ret = false;
        switch(item){
          case 'changeTariff':
            const status = this.currentProduct.status.toLowerCase();
            const acceptedStatuses = ['trial','trial expired','provisioned','ready','live','bad debt','blocked bad debt','pending cease bad debt'];
            const disabledStatuses = ['upgrade','legacy upgrade'];
            ret = (this.currentProduct.status!==undefined)?!acceptedStatuses.includes(status):false;
            ret = (this.currentProduct.status!==undefined)?disabledStatuses.includes(status):false;
            if(!ret){ ret = this.currentProduct.sold_date===null && !['trial','trial expired'].includes(status); }
            break;
          case 'true':
            ret = true;
            break;
        }
        return ret;
      },
      isHidden(item){
        let ret = false;
        switch(item){
          case 'createBilling':
            ret = (this.currentLead.account_id===null);
            break;
          case 'portToBonlineVoip':
            ret = (this.currentProduct.product_kind!==undefined)?this.currentProduct.product_kind.toLowerCase() === 'telco':false;
            break;
          case 'convertToWeb2':
            ret = (this.currentProduct.tariff_version!==undefined)?this.currentProduct.tariff_version.toLowerCase()!=='tariff_v2':false;
            let statuses = ['warm','index','mbw','google status'];
            ret = (!ret)?false:(this.currentProduct.status!==undefined)?statuses.indexOf(this.currentProduct.status.toLowerCase())!==-1:false;
            break;
        }
        return ret;
      },
      hasBadge(badge){
        let ret = false;
        switch(badge){
          case 'escalation':
            ret = (this.openEscalations.length!==0)?this.openEscalations.length:false;
            break;
        }
        return ret;
      },

      disableMenuItem(pageType, menuItem) {
        if (pageType === 'accounts') {
          if (menuItem === 'Tools') {
            return this.getSingleRetentionLead.status === 'Closed';
          }
        }
        return false;
      },

      isSubItemHidden(subItem) {
        switch(subItem) {
          case 'changeTariff':
            return this.currentProduct.tariff_version === 'TARIFF_V3';
          case 'legacyChangeTariffVoip':
            return this.currentProduct.tariff_version === 'TARIFF_V1' || this.currentProduct.tariff_version === 'TARIFF_V2';
          default:
            return false;
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .v-btn{
    &:before{
      background-color: #FFFFFF !important;
    }
  }
</style>
